import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

// Two-column proactive positioning — inspired by the "Good accountants answer
// questions. Great ones prevent them." reference.
export default function ProactiveSplit({
    image,
    kicker = "Our approach",
    headlineLead = "Good accountants answer questions.",
    headlineAccent = "Great ones prevent them.",
    blurb,
    blurbs,
    ctaHref = "/contact",
    ctaLabel = "Schedule a Free Consultation",
}) {
    const paragraphs = blurbs && blurbs.length ? blurbs : [blurb];
    return (
        <section className="section container-page" data-testid="proactive-split">
            <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
                <div className="lg:col-span-7 order-2 lg:order-1">
                    <p className="overline mb-4 text-brand-amber">{kicker}</p>
                    <h2 className="display text-4xl md:text-5xl lg:text-6xl text-brand-ink leading-[1.05]">
                        {headlineLead}{" "}
                        <span className="italic text-brand-amber">{headlineAccent}</span>
                    </h2>
                    <div className="mt-7 max-w-xl space-y-4 text-brand-ink/75 leading-relaxed">
                        {paragraphs.filter(Boolean).map((p, i) => (
                            <p key={i}>{p}</p>
                        ))}
                    </div>
                    <Link to={ctaHref} className="btn-primary mt-9" data-testid="proactive-cta">
                        {ctaLabel} <ArrowUpRight size={16} />
                    </Link>
                </div>
                <div className="lg:col-span-5 order-1 lg:order-2">
                    <div className="relative">
                        <div className="absolute -inset-5 rounded-[2rem] bg-brand-ink/5 -z-10" aria-hidden="true" />
                        <img
                            src={image}
                            alt=""
                            loading="lazy"
                            className="w-full h-[420px] md:h-[520px] object-cover rounded-[1.75rem]"
                            style={{ boxShadow: "0 28px 60px -22px rgba(20,34,57,0.32)" }}
                        />
                    </div>
                </div>
            </div>
        </section>
    );
}
